module.exports = __webpack_public_path__ + "img/Dunhuang.4f066cb7.svg";